import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import '@web/shared-digital-library/icons/svg-originals/infobulle.svg';
import '@web/shared-digital-library/icons/svg-originals/geoloc.svg';
import { mapGetters, mapActions } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import Banner from '~/components/specific/MainHeader/Banner.vue';
import BannerMobile from '~/components/specific/MainHeader/BannerMobile.vue';
import LayerFullscreenHeader from '~/components/specific/MainHeader/LayerFullscreenHeader.vue';
import LayerMobile from '~/components/specific/MainHeader/LayerMobile.vue';
import NavigationBar from '~/components/specific/MainHeader/NavigationBar.vue';
import { FAQ } from '~/const/faq';
import USE_MERCURE from '~/const/mercure';
import focusElement from '~/helpers/a11y-helpers';
import marketClosed from '~/helpers/marketClosed';
var LayerDesktop = function LayerDesktop() {
  return import('~/components/specific/MainHeader/LayerDesktop.vue');
};
export default {
  name: 'MainHeader',
  components: {
    Banner: Banner,
    BannerMobile: BannerMobile,
    NavigationBar: NavigationBar,
    LayerFullscreenHeader: LayerFullscreenHeader,
    LayerMobile: LayerMobile,
    LayerDesktop: LayerDesktop
  },
  props: {
    hashFirstCat: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      isMenuOpened: '',
      selectedItem: null,
      scrollPosition: 0,
      displayNavBar: true,
      enableNavTransition: false,
      lastActiveElement: null,
      stickyFilters: null,
      routesOnNavModifications: ['market-language-c-alias', 'market-language-p-alias'],
      allRoutesForScrambleLinksExept: ['market-language']
    };
  },
  head: function head() {
    return {
      bodyAttrs: {
        class: this.bodyClasses
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    homeUrl: 'i18n/homeUrl',
    user: 'user/me',
    navigation: 'navigationBar/navigation',
    navigationServices: 'navigationBar/navigationServices'
  })), {}, {
    isCurrentRouteNeedsScrambleLinksForHeader: function isCurrentRouteNeedsScrambleLinksForHeader() {
      return !this.allRoutesForScrambleLinksExept.includes(this.$route.name);
    },
    isCurrentRouteNeedsSEOOptimisation: function isCurrentRouteNeedsSEOOptimisation() {
      return this.routesOnNavModifications.includes(this.$route.name);
    },
    hashFromBreadcrumb: function hashFromBreadcrumb() {
      return this.getHash();
    },
    navigationFiltered: function navigationFiltered() {
      var _this$navigation;
      var cloneNav;
      var isConfigReadyForNewMenu = !!(this.isCurrentRouteNeedsSEOOptimisation && this.hashFromBreadcrumb);
      if (isConfigReadyForNewMenu) {
        cloneNav = cloneDeep(this.navigation);
      }
      var isFlatable = function isFlatable(menuItem) {
        return menuItem.flatable;
      };
      var menuProductsIndex = (_this$navigation = this.navigation) === null || _this$navigation === void 0 ? void 0 : _this$navigation.findIndex(isFlatable);
      return isConfigReadyForNewMenu ? this.setNewMenu({
        menu: cloneNav,
        menuProductsIndex: menuProductsIndex,
        hash: this.hashFromBreadcrumb
      }) : this.navigation;
    },
    bodyClasses: function bodyClasses() {
      return this.isMenuOpened ? 'no-scroll w-100' : '';
    },
    accountUrl: function accountUrl() {
      if (this.user && USE_MERCURE(this.locale.iso)) {
        return "".concat(this.homeUrl, "/user");
      }
      if (USE_MERCURE(this.locale.iso)) {
        return "".concat(this.homeUrl, "/login");
      }
      return "".concat(this.homeUrl, "/account/dashboard");
    },
    faqUrl: function faqUrl() {
      var _this = this;
      return FAQ.find(function (e) {
        return e.language === _this.locale.iso;
      }).url;
    },
    urls: function urls() {
      return {
        cartUrl: this.buildCartUrl(this.locale),
        homeUrl: this.homeUrl,
        storeLocUrl: "".concat(this.homeUrl, "/store-locator"),
        helpUrl: this.faqUrl,
        accountUrl: this.accountUrl
      };
    },
    isMarketOpen: function isMarketOpen() {
      if (!this.locale) return true;
      var market = this.locale.market;
      return !marketClosed({
        market: market
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var draftId;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            draftId = _this2.$cookies.get('NAVIGATION_PREVIEW');
            if (!draftId) {
              _context.next = 11;
              break;
            }
            if (_this2.$cookies.get('debugmdm')) _this2.$logger.debug('Previewing draft', draftId);
            _context.prev = 3;
            _context.next = 6;
            return _this2.navigationBarContent({
              draftId: draftId
            });
          case 6:
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](3);
            _this2.$logger.error(_context.t0);
          case 11:
            document.addEventListener('click', _this2.onClickOutside);
            window.addEventListener('scroll', _this2.handleScroll, {
              passive: true
            });
            _this2.scrollPosition = window.pageYOffset;
            _this2.displayNavBar = !_this2.isMobile();
            _this2.$nextTick(function () {
              _this2.enableNavTransition = true;
            });
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 8]]);
    }))();
  },
  destroyed: function destroyed() {
    document.removeEventListener('click', this.onClickOutside);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    navigationBarContent: 'navigationBar/navigationBarContent'
  })), {}, {
    getHash: function getHash() {
      var _this$$store, _this$$store2;
      var indexInBreadcrumbToGetHashCategory = 1;
      var breadcrumbFromProductPage = (_this$$store = this.$store) === null || _this$$store === void 0 ? void 0 : _this$$store.getters['product/breadcrumb'];
      var breadcrumbFromCategoryPage = (_this$$store2 = this.$store) === null || _this$$store2 === void 0 ? void 0 : _this$$store2.getters['category/breadcrumb'];
      if (breadcrumbFromProductPage) {
        var _breadcrumbFromProduc;
        return (_breadcrumbFromProduc = breadcrumbFromProductPage[indexInBreadcrumbToGetHashCategory]) === null || _breadcrumbFromProduc === void 0 ? void 0 : _breadcrumbFromProduc.hash;
      }
      if (breadcrumbFromCategoryPage) {
        var _breadcrumbFromCatego;
        return (_breadcrumbFromCatego = breadcrumbFromCategoryPage[indexInBreadcrumbToGetHashCategory]) === null || _breadcrumbFromCatego === void 0 ? void 0 : _breadcrumbFromCatego.hash;
      }
      return null;
    },
    setNewMenu: function setNewMenu(_ref) {
      var _newMenu$menuProducts;
      var _ref$menu = _ref.menu,
        menu = _ref$menu === void 0 ? null : _ref$menu,
        menuProductsIndex = _ref.menuProductsIndex,
        hash = _ref.hash;
      var newMenu = menu;
      var categoryIndexToNoScramble = newMenu === null || newMenu === void 0 ? void 0 : (_newMenu$menuProducts = newMenu[menuProductsIndex]) === null || _newMenu$menuProducts === void 0 ? void 0 : _newMenu$menuProducts.items.findIndex(function (menu) {
        return JSON.stringify(menu).includes(hash);
      });
      if (categoryIndexToNoScramble !== -1) {
        var _newMenu$menuProducts2;
        this.addScrumbleLinks({
          arrayItems: newMenu === null || newMenu === void 0 ? void 0 : (_newMenu$menuProducts2 = newMenu[menuProductsIndex]) === null || _newMenu$menuProducts2 === void 0 ? void 0 : _newMenu$menuProducts2.items,
          indexArrayItemNoScramble: categoryIndexToNoScramble
        });
      }
      return newMenu;
    },
    addScrumbleLinks: function addScrumbleLinks(_ref2) {
      var _ref2$arrayItems = _ref2.arrayItems,
        arrayItems = _ref2$arrayItems === void 0 ? [] : _ref2$arrayItems,
        _ref2$indexArrayItemN = _ref2.indexArrayItemNoScramble,
        indexArrayItemNoScramble = _ref2$indexArrayItemN === void 0 ? null : _ref2$indexArrayItemN;
      arrayItems.forEach(function (menuEle) {
        var menuEleCopy = menuEle;
        menuEleCopy.isScrambleLink = true;
      });
      if (indexArrayItemNoScramble || indexArrayItemNoScramble === 0) {
        var menuProductToOptimise = arrayItems === null || arrayItems === void 0 ? void 0 : arrayItems[indexArrayItemNoScramble];
        if (menuProductToOptimise) menuProductToOptimise.isScrambleLink = false;
      }
    },
    openMenu: function openMenu(items) {
      var _this3 = this;
      this.selectedItem = items;
      if (items === 'mobile') {
        this.isMenuOpened = 'mobile';
      } else {
        this.isMenuOpened = items && this.isMenuOpened !== items.label ? items.label : '';
        this.lastActiveElement = document.activeElement;
        this.$nextTick(function () {
          return focusElement(_this3.$refs.layerFullscreen.$refs.close.$el);
        });
      }
    },
    closeMenu: function closeMenu() {
      this.isMenuOpened = '';
      this.selectedItem = null;
      this.$refs.layerMobile.close();
    },
    handleScroll: function handleScroll() {
      if (this.isMobile()) {
        this.displayNavBar = false;
        return;
      }
      var scroll = window.pageYOffset;
      this.displayNavBar = this.scrollPosition > scroll || scroll <= 1;
      this.scrollPosition = scroll;
    },
    onClickOutside: function onClickOutside(event) {
      var _this$$refs = this.$refs,
        navigationBar = _this$$refs.navigationBar,
        layerFullscreen = _this$$refs.layerFullscreen,
        bannerMobile = _this$$refs.bannerMobile,
        layerMobile = _this$$refs.layerMobile;
      if (!navigationBar || navigationBar.$el.contains(event.target) || !layerFullscreen || layerFullscreen.$el.contains(event.target) || !bannerMobile || bannerMobile.$el.contains(event.target) || !layerMobile || layerMobile.$el.contains(event.target)) return;
      this.closeMenu();
    }
  })
};